export default "__VITE_ASSET__18$0_yYb__"